<div class="form-wrapper">
  <lsz-edit-form-header
    [headerText]="'Systeme'"
    [numEntries]="entries.length"
    [editMode]="editMode"
    (clickEdit)="onClickEdit()"
    (clickEditDone)="onClickEditDone()"
  ></lsz-edit-form-header>

  <table [class.editMode]="editMode" [formGroup]="allForms">
    <thead>
    <tr>
      <th i18n="@@tableHeaderName">Name</th>
      <th i18n="@@tableHeaderMedicine">Medizin</th>
      <th i18n="@@tableHeaderPlayers">Spieler</th>
      <th i18n="@@tableHeaderScouting">Scouting</th>
      <th i18n="@@tableHeaderStaff">Personal</th>
      <th i18n="@@tableHeaderStrategy">Strategie</th>
      <th i18n="@@tableHeaderSupport">Unterstützung</th>
      <th i18n="@@tableHeaderVideo">Video</th>
      <th *ngIf="editMode" i18n="@@tableHeaderOptions" class="column-options">Optionen</th>
      <th>{{'lastEdit' | translate}}</th>
    </tr>
    </thead>
    <tbody
      lsz-database-system-form
      *ngFor="let form of customEntryForms.controls; let i = index"
      (entrySaved)="onUpdate(i)"
      (entryDeleted)="onDelete(i)"
      [editMode]="editMode"
      formArrayName="customEntries"
      [index]="i"
      [form]="form"
    >
    </tbody>
    <tbody *ngIf="addMode" formGroupName="newEntry">
    <tr>
      <td>
        <input type="text" placeholder="Neuer Eintrag" i18n-placeholder="@@placeholderNewEntry" formControlName="name" required/>
        <div *ngIf="name.invalid && (name.dirty || name.touched)">
          <div class="input-error" *ngIf="name.errors.required">Name wird benötigt.</div>
          <div class="input-error" *ngIf="name.errors.repeatedName">Name kann sich nicht wiederholen.</div>
        </div>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'medicine'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'players'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'scouting'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'staff'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'strategy'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'support'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'video'"></lsz-binary-select>
      </td>
      <td>
        <div class="form-options" fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
          <button
            type="button"
            [disabled]="!newEntryForm.valid"
            (click)="createNewEntry()"
            class="nav-button"
            [ngClass]="{'notice': newEntryForm.valid}"
          >
            <fa-icon [icon]="faSave"></fa-icon>
          </button>
          <button type="button" (click)="exitAddMode()" class="nav-button">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <button *ngIf="editMode && !addMode" type="button" (click)="addNewRow()" i18n="@@dataButtonAdd" class="add-button">
    <fa-icon [icon]="faPlus"></fa-icon>
    Neuen Eintrag hinzufügen
  </button>
</div>
